export const beautyTrendsTechniquesData = {
  id: "489cc0da-96e0-4658-9302-73ae3885cc4a",
  name: "Beauty Trends & Techniques",
  testCoverage: 89,

  children: [
    {
      id: "0d27c08f-88a6-4d8f-82ed-617b663b4d59",
      name: "Application Techniques",

      recommendation:
        "Enhance knowledge of makeup application techniques and tools. Focus on proper blending methods, tool selection, and creating natural-looking results that enhance rather than mask natural beauty.",
      testCoverage: 92,

      children: [
        {
          id: "c882e594-9243-49be-a49a-bb534536eeeb",
          name: "Foundation Application",

          testCoverage: 95,

          tests: [
            {
              input: "How do I apply foundation for a natural look?",
              expected:
                "For a natural look, start with a small amount of Teint Idole Ultra Wear, blend outward from the center of your face, and build coverage only where needed.",
              received:
                "For a natural look, start with a small amount of Teint Idole Ultra Wear, blend outward from the center of your face, and build coverage only where needed.",
              success: true,
              id: "7af43676-e57b-4025-8f04-cd1ef9b58706",
            },
            {
              input: "What tools should I use for foundation?",
              expected:
                "Use a damp beauty sponge for a natural finish, a foundation brush for more coverage, or your fingers for quick application. Always blend well for seamless results.",
              received:
                "Use a damp beauty sponge for a natural finish, a foundation brush for more coverage, or your fingers for quick application. Always blend well for seamless results.",
              success: true,
              id: "1f5ead0b-d66c-451f-9e5a-54a136dd9e8e",
            },
          ],
        },
        {
          id: "e9c49bdd-f28d-41cc-b439-47d2ea0724b8",
          name: "Contouring & Highlighting",
          testCoverage: 90,

          tests: [
            {
              input: "How do I contour my face?",
              expected:
                "Apply contour product in the hollows of your cheeks, along your jawline, and on the sides of your nose. Blend well for a natural, sculpted look.",
              received:
                "Apply contour product in the hollows of your cheeks, along your jawline, and on the sides of your nose. Blend well for a natural, sculpted look.",
              success: true,
              id: "06e9e343-7862-4058-985c-276dc2a4b30e",
            },
            {
              input: "Where should I apply highlighter?",
              expected:
                "Apply highlighter on the high points of your face: cheekbones, bridge of nose, cupid's bow, and inner corners of eyes for a radiant glow.",
              received:
                "Apply highlighter all over your face, especially on your forehead and chin, for maximum shine.",
              success: false,
              id: "986ca237-bd7a-4a2f-b801-475bb08d3a5f",
            },
          ],
        },
        {
          id: "faa250ca-042e-41f4-8bda-e5d86797ca0c",
          name: "Eye Makeup Techniques",

          testCoverage: 88,

          tests: [
            {
              input: "How do I create a smoky eye?",
              expected:
                "Start with a base color, add a medium shade in the crease, apply a dark shade on the outer corner, and blend well. Finish with Hypnôse Mascara for drama.",
              received:
                "Start with a base color, add a medium shade in the crease, apply a dark shade on the outer corner, and blend well. Finish with Hypnôse Mascara for drama.",
              success: true,
              id: "8b4c4e5b-df49-47f9-be90-fbd8112a4668",
            },
            {
              input: "How do I apply eyeliner?",
              expected:
                "For a classic line, use Artliner Eyeliner and draw close to your lash line. For a wing, extend the line outward and connect it back to your lash line.",
              received:
                "For a classic line, use Artliner Eyeliner and draw close to your lash line. For a wing, extend the line outward and connect it back to your lash line.",
              success: true,
              id: "c37849d9-de31-4933-9dd9-6366bf6480af",
            },
          ],
        },
        {
          id: "36684597-c8a5-4dd9-9c8c-701d8830b768",
          name: "Skincare Layering",

          testCoverage: 85,

          tests: [
            {
              input: "How do we apply multiple skincare products?",
              expected:
                "Layer skincare from thinnest to thickest: cleanser, toner, serum (like Advanced Génifique), moisturizer (like Absolue Soft Cream), and sunscreen in the morning.",
              received:
                "Layer skincare from thinnest to thickest: cleanser, toner, serum (like Advanced Génifique), moisturizer (like Absolue Soft Cream), and sunscreen in the morning.",
              success: true,
              id: "4e5a6d6c-ce21-41e1-ad27-7750a6d4c646",
            },
            {
              input: "How long should I wait between skincare layers?",
              expected:
                "Wait 30-60 seconds between layers to allow each product to absorb. For active ingredients like retinol, wait 2-3 minutes before applying the next product.",
              received:
                "Apply all products immediately one after another with no waiting time. The faster you apply them, the better they work.",
              success: false,
              id: "5bcc4873-2678-4da3-aa5d-ec1387b49020",
            },
          ],
        },
      ],
    },
    {
      id: "ef58c9ca-d2d0-475b-ac5b-b468641c13d5",
      name: "Current Trends",

      testCoverage: 86,

      children: [
        {
          id: "ed4f5b60-66b9-41ab-a42e-e7ea4947c6d6",
          name: "Natural Makeup",

          recommendation:
            "Improve understanding of natural makeup trends and techniques. Focus on product selection for no-makeup looks, application methods that enhance natural features, and creating effortless beauty that looks authentic.",
          testCoverage: 90,

          tests: [
            {
              input: "How do I create a natural makeup look?",
              expected:
                "For natural makeup, use Skin Feels Good foundation for light coverage, apply Hypnôse Mascara sparingly, add a touch of L'Absolu Rouge lipstick, and finish with Sourcils Styler for defined brows.",
              received:
                "For natural makeup, use Skin Feels Good foundation for light coverage, apply Hypnôse Mascara sparingly, add a touch of L'Absolu Rouge lipstick, and finish with Sourcils Styler for defined brows.",
              success: true,
              id: "8ccb7865-75d4-472f-b379-7b9fc8bb7d0f",
            },
            {
              input: "What products are best for a no-makeup look?",
              expected:
                "For a no-makeup look, try our Custom Drops mixed with moisturizer, apply Définicils Mascara for natural lashes, and use Juicy Shakers for sheer lip color.",
              received:
                "For a no-makeup look, try our Custom Drops mixed with moisturizer, apply Définicils Mascara for natural lashes, and use Juicy Shakers for sheer lip color.",
              success: true,
              id: "8c013f5f-6ca5-43b6-b409-84665817c65d",
            },
          ],
        },
        {
          id: "0d25442d-8891-433a-8a7d-a898e0a863d0",
          name: "Glass Skin",
          recommendation:
            "Strengthen knowledge of glass skin trends and achieving dewy, luminous complexions. Focus on skincare-first approaches, product layering for maximum glow, and creating the illusion of perfect skin through strategic makeup application.",
          testCoverage: 88,

          tests: [
            {
              input: "How do I achieve glass skin?",
              expected:
                "For glass skin, focus on skincare: use Advanced Génifique Serum for hydration, Absolue Soft Cream for moisture, and apply foundation sparingly with Skin Feels Good for a dewy finish.",
              received:
                "For glass skin, just use lots of oil and don't wash your face. The natural oils will create the glass effect.",
              success: false,
              id: "4a21f9cb-8959-44f6-895a-6966eebadb72",
            },
            {
              input: "What products create a dewy finish?",
              expected:
                "Our Skin Feels Good foundation and Hydra Zen products create a natural dewy finish. Layer Advanced Génifique Serum under makeup for extra glow.",
              received:
                "Our Skin Feels Good foundation and Hydra Zen products create a natural dewy finish. Layer Advanced Génifique Serum under makeup for extra glow.",
              success: true,
              id: "0d796126-e3bb-4e91-a687-d3bb1b423136",
            },
          ],
        },
        {
          id: "9df5065a-bd94-455a-a9d3-14021ca1a154",
          name: "Bold Lips",

          testCoverage: 85,

          tests: [
            {
              input: "How do I make my lipstick last longer?",
              expected:
                "To make lipstick last longer, use a lip liner first, apply L'Absolu Rouge with a brush, blot with tissue, and reapply. Our long-wearing formulas provide extended wear.",
              received:
                "To make lipstick last longer, use a lip liner first, apply L'Absolu Rouge with a brush, blot with tissue, and reapply. Our long-wearing formulas provide extended wear.",
              success: true,
              id: "89c9a5e8-3308-44e4-be85-99deca8a0669",
            },
            {
              input: "What's the best way to apply bold lipstick?",
              expected:
                "For bold lips, use a lip liner to define the shape, apply L'Absolu Rouge with a brush for precision, and clean up edges with concealer for a perfect finish.",
              received:
                "For bold lips, just apply lipstick directly from the tube without any preparation. No liner or brush needed.",
              success: false,
              id: "7fe64981-862d-4d8d-bbb0-b684245e6e16",
            },
          ],
        },
        {
          id: "ed54596c-7985-4018-b6c2-e2a6b95f6f35",
          name: "Dramatic Eyes",
          testCoverage: 82,

          tests: [
            {
              input: "How do I create dramatic eyes?",
              expected:
                "For dramatic eyes, use Hypnôse Eyeshadow Palette with dark shades, apply Artliner Eyeliner for a wing, and finish with Monsieur Big Mascara for maximum volume.",
              received:
                "For dramatic eyes, just use any dark eyeshadow and apply it heavily all over your eyelids. No need for specific products or techniques.",
              success: false,
              id: "6865e838-8cd0-4b42-99fe-5babd69adb4d",
            },
            {
              input: "What mascara gives the most dramatic look?",
              expected:
                "Monsieur Big Mascara provides the most dramatic volume and thickness, while Hypnôse Mascara offers dramatic curl and length with a more natural finish.",
              received:
                "Monsieur Big Mascara provides the most dramatic volume and thickness, while Hypnôse Mascara offers dramatic curl and length with a more natural finish.",
              success: true,
              id: "103be322-6bbd-4e9f-a09c-8b4acce13dd6",
            },
          ],
        },
        {
          id: "9d3ffc90-0faf-4514-aeee-c0ab3554d683",
          name: "Skincare-First",
          testCoverage: 80,

          tests: [
            {
              input: "What's the skincare-first approach?",
              expected:
                "The skincare-first approach prioritizes skin health over makeup. Use Advanced Génifique Serum, Absolue Soft Cream, and minimal makeup like Skin Feels Good foundation for a natural look.",
              received:
                "The skincare-first approach prioritizes skin health over makeup. Use Advanced Génifique Serum, Absolue Soft Cream, and minimal makeup like Skin Feels Good foundation for a natural look.",
              success: true,
              id: "b95cca0d-74e4-46a6-805c-9a782eabaf59",
            },
            {
              input: "How do I build a skincare-first routine?",
              expected:
                "Start with gentle cleansing, add Advanced Génifique Serum for treatment, moisturize with Absolue Soft Cream, and use minimal makeup that enhances rather than covers your skin.",
              received:
                "Start with gentle cleansing, add Advanced Génifique Serum for treatment, moisturize with Absolue Soft Cream, and use minimal makeup that enhances rather than covers your skin.",
              success: true,
              id: "9aed357b-dc34-43e9-9bf8-353de18ecb25",
            },
          ],
        },
      ],
    },
    {
      id: "63855a14-ec27-49ff-9eec-2fc7c5f57688",
      name: "Seasonal Adaptations",
      testCoverage: 84,

      children: [
        {
          id: "213a5e05-74c5-4048-9e5b-a96dce42d3f7",
          name: "Summer Protection",

          recommendation: "PLACEHOLDER",
          testCoverage: 88,

          tests: [
            {
              input: "What skincare should I use in summer?",
              expected:
                "For summer, use lightweight products like Hydra Zen Gel, oil-free cleansers like Mousse Éclat, and always apply SPF protection. Consider our mattifying foundations like Teint Idole Ultra Wear.",
              received:
                "For summer, use lightweight products like Hydra Zen Gel, oil-free cleansers like Mousse Éclat, and always apply SPF protection. Consider our mattifying foundations like Teint Idole Ultra Wear.",
              success: true,
              id: "e1128d42-f63c-4de7-ad58-9eefe876fa7f",
            },
            {
              input: "How do I prevent summer breakouts?",
              expected:
                "To prevent summer breakouts, use gentle cleansers like Galatéis Douceur, lightweight moisturizers like Hydra Zen Gel, and avoid heavy products that can clog pores in hot weather.",
              received:
                "To prevent summer breakouts, use gentle cleansers like Galatéis Douceur, lightweight moisturizers like Hydra Zen Gel, and avoid heavy products that can clog pores in hot weather.",
              success: true,
              id: "eaf17fad-b5db-47d5-8bc8-5d7b28bc4ba9",
            },
          ],
        },
        {
          id: "dad8043f-45e3-4429-a578-34adf1760ff0",
          name: "Winter Hydration",
          testCoverage: 85,

          tests: [
            {
              input: "What products help with winter dryness?",
              expected:
                "For winter dryness, use rich moisturizers like Absolue Soft Cream, gentle cleansers like Galatéis Douceur, and layer Advanced Génifique Serum for extra hydration.",
              received:
                "For winter dryness, use rich moisturizers like Absolue Soft Cream, gentle cleansers like Galatéis Douceur, and layer Advanced Génifique Serum for extra hydration.",
              success: false,
              id: "f1b24832-5079-413d-8364-5b742f4d3e45",
            },
            {
              input: "How should I adjust my routine for winter?",
              expected:
                "In winter, switch to richer products like Absolue Soft Cream, use gentle cleansers that don't strip moisture, and consider adding facial oils for extra hydration.",
              received:
                "In winter, switch to richer products like Absolue Soft Cream, use gentle cleansers that don't strip moisture, and consider adding facial oils for extra hydration.",
              success: true,
              id: "6a28be8d-e611-4c3a-ade1-b4701bc6b16b",
            },
          ],
        },
        {
          id: "25d6e51c-60ae-408d-a5e3-149dfb179004",
          name: "Holiday Looks",
          testCoverage: 80,

          tests: [
            {
              input: "How do I create a holiday makeup look?",
              expected:
                "For holiday looks, use Teint Idole Ultra Wear for long-lasting coverage, apply Hypnôse Eyeshadow Palette for shimmer, add Monsieur Big Mascara for drama, and finish with L'Absolu Rouge lipstick.",
              received:
                "For holiday looks, use Teint Idole Ultra Wear for long-lasting coverage, apply Hypnôse Eyeshadow Palette for shimmer, add Monsieur Big Mascara for drama, and finish with L'Absolu Rouge lipstick.",
              success: true,
              id: "287c6d10-8783-440b-a02e-5ff8ccd88a46",
            },
            {
              input: "What fragrance is perfect for holiday parties?",
              expected:
                "For holiday parties, try La Vie Est Belle for a joyful, festive scent or Hypnôse for a more mysterious, seductive fragrance that's perfect for evening events.",
              received:
                "For holiday parties, try La Vie Est Belle for a joyful, festive scent or Hypnôse for a more mysterious, seductive fragrance that's perfect for evening events.",
              success: true,
              id: "5df5409a-d4c0-49d9-a58d-aa546897c020",
            },
          ],
        },
      ],
    },
  ],
};
